import React from 'react';
import moment from 'moment';
import SystemMessagePreview from 'components/SystemMessagePreview';
import { Button } from 'ui-library';

const PreviewSystemMessage = ({
    title,
    body,
    link,
    document,
    t,
    startDate,
    endDate,
    platforms,
    onClose,
}) => (
    <div className="preview-system-message">
        <SystemMessagePreview
            title={title}
            body={body}
            link={link}
            document={document}
        />

        <div className="system-message-field-seperator" />
        <p className="system-message-info-title">
            {t('SystemMessage.Form.Preview.Info.Title')}
            :
        </p>
        <div className="system-message-info">
            <strong>
                {t('SystemMessage.Form.Preview.Info.Start')}
                :
            </strong>
            {' '}
            {startDate
                ? moment.utc(startDate).format('DD.MM.YYYY')
                : t('SystemMessage.Form.Preview.Info.Immediately')}
        </div>
        <div className="system-message-info">
            <strong>
                {t('SystemMessage.Form.Preview.Info.End')}
                :
            </strong>
            {' '}
            {endDate
                ? moment.utc(endDate).format('DD.MM.YYYY')
                : t('SystemMessage.Form.Preview.Info.NotSet')}
        </div>
        <div className="system-message-info">
            <strong>
                {t('SystemMessage.Form.Preview.Info.Platform')}
                :
            </strong>
            {' '}
            {platforms}
        </div>
        <div className="system-message-field-seperator" />
        <div className="system-message-fields--actions flex-end">
            <Button type="primary" onClick={onClose}>
                {t('clientDashboard.close')}
            </Button>
        </div>
    </div>
);

export default PreviewSystemMessage;
